import {
		CHANGE_SEARCH_FIELD,
		REQUEST_ROBOTS_PENDING,
		REQUEST_ROBOTS_SUCCESS,
		REQUEST_ROBOTS_FAILED
	} from './constants.js'
import env from "react-dotenv";
let URL = `${env.API_URL}/p10`

export const setSearchField = (text) => ({

	type: CHANGE_SEARCH_FIELD,
	payload: text
})

export const requestRobots = () => (dispatch) => {
	dispatch({ type: REQUEST_ROBOTS_PENDING})
	fetch(URL)
		.then(response => response.json())
		.then(data => dispatch({type: REQUEST_ROBOTS_SUCCESS, payload: data}))
		.catch(error => dispatch({type: REQUEST_ROBOTS_FAILED, payload: error}))
	}

export const CLEAR_SEARCH_FIELD = 'CLEAR_SEARCH_FIELD';

export const clearSearchField = () => ({
  type: CLEAR_SEARCH_FIELD
});


